export default {
  unavailable: 'Tento blok už nie je dostupný a v správe bude vynechaný.',
  onlyIncludedFor: 'Zahrnuté len pri exporte pre: {scopes}',
  configuration: 'Konfigurácia',
  template: 'Šablóna',
  replaced: 'Nahradená',
  default: 'Predvolená',
  variables: 'Premenné',
};
